import { createApp } from 'vue'
import {createPinia} from "pinia";
import App from './App.vue'
import router from './router'
import vueMiddleware from 'vue-middleware'
import middleware from "@/middleware";

import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-icons/font/bootstrap-icons.css"

const app = createApp(App)
const pinia = createPinia()

import '@/assets/css/index.css'

app
    .use(router)
    .use(vueMiddleware, {middleware})
    .use(pinia)
    .mount('#app')